<ng-container [formGroup]="formGroup">

  <div class="app-datepicker">
    <div class="group-container" [ngClass]="{'disabled': disabled, 'field-error': hasError()}" (focusout)="isTouched = true">

      <input type="hidden" *ngIf="controlName" [formControlName]='controlName' [required]="required">
      <input type="hidden" *ngIf="!controlName" [(value)]="selectedDate">

      <div class="control">
        <ng-container *ngIf="isHijri">
          <app-islamic-picker class="flex-grow-1"
            [disabled]="disabled"
            [minDate]="minDate.hijri"
            [maxDate]="maxDate.hijri"
            [label]="label"
            [(dateValue)]="selectedDate"
            [placement]="placement"
            (dateValueChange)="setDate($event)"></app-islamic-picker>
        </ng-container>

        <ng-container *ngIf="!isHijri">
          <input readonly
            [disabled]="disabled"
            [minDate]="minDate.gregorian"
            [maxDate]="maxDate.gregorian"
            [(ngModel)]="selectedDate" [ngModelOptions]="{standalone: true}"
            (dateSelect)="setFieldControlValue()"
            [footerTemplate]="footerTemplate"
            [placement]="placement"
            ngbDatepicker #dp="ngbDatepicker" (click)="!disabled ? dp.toggle() : null">
            <label (click)="!disabled ? dp.toggle() : null">{{label}}</label>

            <ng-template #footerTemplate>
              <hr class="my-0">
              <div class="p-3 d-flex justify-content-between align-items-center">
                <button class="btn btn-primary btn-sm" *ngIf="showToday" type="button" [disabled]="disabled" (click)="setDate(today); dp.close()">{{ 'general.Today' | translate }}</button>
                <button class="btn btn-secondary btn-sm" type="button" [disabled]="disabled" (click)="setDate(); dp.close()">{{ 'general.Clear' | translate }}</button>
              </div>
            </ng-template>
        </ng-container>
      </div>

      <div class="type-change">
        <button type="button"
          [class.active]='isHijri'
          (click)="changeDateType(true)">{{'general.H' | translate}}</button>

        <button type="button"
          [class.active]='!isHijri'
          (click)="changeDateType(false)">{{'general.G' | translate}}</button>
      </div>
    </div>

    <p class="custom-error" *ngIf="hasError('required')" [class.active]="hasError('required')">
      {{ 'forms.Required' | translate }}
    </p>
    <p class="custom-error" *ngIf="hasError('invalid')" [class.active]="hasError('invalid')">
      {{ invalidMsg || ('forms.Invalid Date' | translate) }}
    </p>
  </div>

</ng-container>
